import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DemandTypeModel } from '../../Models/Domains/Workflow/DemandTypeModel';
import { DemandType } from '../../Models/Domains/Workflow/DemandType';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class DemandTypeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(demandType: DemandType, demandLvl: number, demandTypeDs: string, demandFullDs: string, stopDate: IJsonDate): Promise<Array<DemandTypeModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/DemandType/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { demandType: demandType, demandLvl: demandLvl, demandTypeDs: demandTypeDs, demandFullDs: demandFullDs, stopDate: stopDate }

    return AjaxWrapper.get<Array<DemandTypeModel>, any>(url, data);
  }
}

